import { badgeDefinition } from '../definitions/badge';
import { buttonDefinition } from '../definitions/button';
import { calendarBadgeDefinition } from '../definitions/calendar-badge';
import { cardDefinition } from '../definitions/card';
import { miniGaugeDefinition } from '../definitions/mini-gauge';
import { progressRingDefinition } from '../definitions/progress-ring';
import { createComponentVariants } from '../factory';

export type WebButtonVariant = keyof typeof buttonDefinition.variants.variant;
export const webButtonVariantClassName = (variant: WebButtonVariant) =>
  buttonDefinition.variants.variant[variant];

export type WebBadgeVariant = keyof typeof badgeDefinition.variants.variant;
export const webBadgeVariantClassName = (variant: WebBadgeVariant) =>
  badgeDefinition.variants.variant[variant];

export type WebCardVariant = keyof typeof cardDefinition.variants.variant;
export const webCardVariantClassName = (variant: WebCardVariant) =>
  cardDefinition.variants.variant[variant];

export const webCalendarBadgeClassName = createComponentVariants(calendarBadgeDefinition);
export const webProgressRingClassName = createComponentVariants(progressRingDefinition);
export const webMiniGaugeClassName = createComponentVariants(miniGaugeDefinition);
